import { useLiveQuery } from "dexie-react-hooks";
import { db } from "../../schema.dexie";
import { emojiExperiencia } from "../emoji";
import type { TipoExperiencia } from "../types";

/**
 * Mostra a imagem da experiência. Procura a 1ª mídia que seja IMAGEM (as mídias
 * podem misturar foto e clipe de áudio); se não houver, cai num emoji por nome/tipo.
 * Indica 🔊 quando há áudio tocável. Reaproveita as classes .foto do app.
 */
export function ExperienciaFoto({
  midias,
  nome,
  tipo,
  className = "",
}: {
  midias?: string[];
  nome?: string | null;
  tipo?: TipoExperiencia | null;
  className?: string;
}) {
  const dados = useLiveQuery(async () => {
    let imagem: Blob | undefined;
    let temAudio = false;
    for (const ref of midias ?? []) {
      const f = await db.foto.get(ref);
      if (!f) continue;
      if (!imagem && f.blob.type.startsWith("image")) imagem = f.blob;
      if (f.blob.type.startsWith("audio")) temAudio = true;
    }
    return { imagem, temAudio };
  }, [(midias ?? []).join(",")]);

  const blobUrl = dados?.imagem ? URL.createObjectURL(dados.imagem) : null;
  const glifo = emojiExperiencia(nome, tipo);

  return (
    <div className={`foto ${className}`} aria-hidden={!blobUrl}>
      {blobUrl ? (
        <img
          src={blobUrl}
          alt=""
          onLoad={() => URL.revokeObjectURL(blobUrl)}
        />
      ) : (
        <span>{glifo}</span>
      )}
      {dados?.temAudio && (
        <span className="foto-audio" aria-hidden>
          🔊
        </span>
      )}
    </div>
  );
}
